import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { DictionariesApi } from '@/api/DictionariesApi';

const state = {
   currencies: [],
   tarification: [],
   vat: [],
};

const mutations: MutationTree<any> = {
   setItems(state, { name, value }) {
      state[name] = value;
   },
};

const getters: GetterTree<any, any> = {};

const actions: ActionTree<any, any> = {
   SET_CURRENCIES({ commit }) {
      return DictionariesApi.currencies().then(value => {
         commit('setItems', { value, name: 'currencies' });
         return Object.keys(value).length;
      });
   },
   SET_tarification({ commit }) {
      return DictionariesApi.tarification().then(value => {
         commit('setItems', { value, name: 'tarification' });
         return value.length;
      });
   },
   SET_VAT({ commit }) {
      return DictionariesApi.vat().then(value => {
         commit('setItems', { value, name: 'vat' });
         return value.length;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
